module.exports = function() {
  return new Worker(__webpack_public_path__ + "f82f61e7dfb07ff0bd6e.worker.js");
};